<script setup lang="ts">
import { cn } from '@/lib/utils'
import { useVModel } from '@vueuse/core'
import { computed, type HTMLAttributes } from 'vue'

defineOptions({
    inheritAttrs: false,
})

const props = defineProps<{
    defaultValue?: string | number
    modelValue?: string | number
    class?: HTMLAttributes['class']
    error?: string
}>()

const emits = defineEmits<{
    (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue,
})

const inputClass = computed(() => {
    const base = 'w-full p-3 border-b ring-0 focus-0 outline-0'
    if (props.error) {
        return base + ' border-b-cupra-danger-dark-theme'
    } else {
        return base + ' border-b-primary'
    }
})
</script>

<template>
    <div class="flex flex-grow-1 flex-col">
        <input
            v-model="modelValue"
            data-slot="input"
            :class="cn(inputClass, props.class)"
            v-bind="$attrs"
        />
        <div
            v-if="error"
            class="text-cupra-danger-dark-theme text-sm"
        >
            {{ error }}
        </div>
    </div>
</template>
